import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Utility function to merge Tailwind classes
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Theme configuration
export const theme = {
  colors: {
    primary: {
      default: '#17214B',
      light: '#2A3674',
      dark: '#090A17',
    },
    accent: {
      default: '#D9A227',
      light: '#EBCB83',
      dark: '#A66F0B',
    },
    text: {
      primary: '#19182A',
      light: '#FAF9F6',
    },
    background: {
      primary: '#FAF9F6',
      secondary: '#F1EEE7',
    },
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
  },
  typography: {
    fontFamily: {
      heading: ['Fraunces Variable', 'Noto Serif', 'serif'],
      body: ['Manrope Variable', 'Noto Sans', 'sans-serif'],
      tamilHeading: ['Noto Serif Tamil Variable', 'Noto Serif', 'serif'],
      tamilBody: ['Noto Sans Tamil Variable', 'Noto Sans', 'sans-serif'],
    },
    fontSize: {
      h1: 'clamp(2rem, 5vw, 3rem)',
      h2: 'clamp(1.5rem, 4vw, 2.5rem)',
      body: 'clamp(1rem, 2vw, 1.125rem)',
    },
  },
} as const;

// Type-safe theme access
export type Theme = typeof theme;
export type ThemeColors = keyof typeof theme.colors;
export type ThemeBreakpoints = keyof typeof theme.breakpoints;
